import { useEffect } from "react";
import { useStore } from "../../hooks/use-store";
import { useHistory, useLocation } from "react-router-dom";

const MainRouter = () => {
  const { uiStore } = useStore();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    // if there was url before login redirect back to it
    console.log(location);
    if (uiStore.initialUrl && uiStore.initialUrl !== location.pathname) {
      history.push(uiStore.initialUrl);
      uiStore.initialUrl = "";
    } else {
      history.push("/");
      // history.push("/account");
    }
    // eslint-disable-next-line
  }, []);

  return <></>;
};

export default MainRouter;
